import React from 'react';

interface AiStarIconProps {
  size?: number;
  className?: string;
}

const AiStarIcon: React.FC<AiStarIconProps> = ({ 
  size = 12, 
  className = '' 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 12 12" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M5.60352 0.802734C5.91988 0.803199 6.18511 1.04113 6.2207 1.35547C6.38369 2.79422 6.81919 3.82122 7.50488 4.51953C8.18681 5.21387 9.1891 5.65648 10.6377 5.78516C10.9591 5.81372 11.2054 6.08354 11.2051 6.40625C11.2046 6.72886 10.958 6.99737 10.6367 7.02539C9.21239 7.14865 8.18645 7.59194 7.4873 8.29102C6.78846 8.99019 6.34589 10.0154 6.22266 11.4395C6.19473 11.7608 5.92612 12.0073 5.60352 12.0078C5.2808 12.0081 5.011 11.7619 4.98242 11.4404C4.85373 9.99195 4.41107 8.98952 3.7168 8.30762C3.01853 7.62197 1.99136 7.18742 0.552734 7.02441C0.23833 6.98882 0.000385305 6.72268 0 6.40625C-0.000320012 6.08996 0.236606 5.82352 0.550781 5.78711C2.01432 5.61828 3.01918 5.18392 3.7002 4.50293C4.3811 3.82198 4.81554 2.81777 4.98438 1.35449C5.02061 1.04013 5.28709 0.802414 5.60352 0.802734ZM10.7969 0.799805C10.8241 0.841943 10.853 0.882313 10.8838 0.920898L10.9824 1.03223L11.0889 1.12988C11.1258 1.16052 11.164 1.18979 11.2041 1.2168L11.9795 1.73828L11.2012 2.25586C11.1198 2.30995 11.0444 2.37166 10.9756 2.44043C10.9071 2.50911 10.8459 2.58402 10.792 2.66504L10.3271 3.36426L9.79102 2.71875L9.55371 2.43262C9.48725 2.36915 9.41492 2.3118 9.33594 2.26074L8.52832 1.73828L9.33301 1.21191C9.41624 1.15742 9.49278 1.09599 9.5625 1.02637L9.66113 0.916992C9.69208 0.8788 9.72078 0.838539 9.74805 0.796875L10.2744 -0.0078125L10.7969 0.799805Z" 
        fill="url(#paint0_linear_6011_15121)"
      />
      <defs>
        <linearGradient 
          id="paint0_linear_6011_15121" 
          x1="-4.21336e-09" 
          y1="6.00002" 
          x2="20.4061" 
          y2="7.16142" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9263"/>
          <stop offset="0.271758" stopColor="#AB5DFF"/>
          <stop offset="0.813578" stopColor="#096EFF"/>
          <stop offset="0.951923" stopColor="#006FFF"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AiStarIcon;